<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close transfer>
			<template #default>
				<vxe-grid ref="list" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_title: '配置规则',
				modal_width:1000,
				modal_height:500,
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = 350
				gridOptions.toolbarConfig = {
					size: 'mini',
					perfect: false,
					buttons: [{
						name: '新增',
						status: 'primary',
						code: 'add'
					}],
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					zoom: true,
					tools: []
				}
				gridOptions.columns = [{
						field: 'logic',
						title: '逻辑',
						editRender: {
							name: '$select',
							props: {
								emptyoptions:false,
								selectoptions:[{
									value:'且',
									label:'且'
								},{
									value:'或',
									label:'或'
								}]
							},
							events: {
								
							}
						},
					}, {
						field: 'field',
						title: '字段',
						editRender: {
							name: '$input',
							props: {},
							events: {
								
							}
						},			
					}, {
						field: 'symbol',
						title: '符号',
						editRender: {
							name: '$select',
							props: {
								emptyoptions:false,
								selectoptions:[{
									value:'包含',
									label:'包含'
								},{
									value:'等于',
									label:'等于'
								}]
							},
							events: {
								
							}
						},
					},{
						field: 'value',
						title: '值',
						editRender: {
							name: '$input',
							props: {},
							events: {
								
							}
						},
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 65,
						slots: {
							default: ({row}) => {
								return [<el-button style="color:#F56C6C;" type = "text" size = "mini" onClick = {() => {this.delete(row)}}>删除</el-button>]
							}
						}
					}
				]
				gridOptions.formConfig = false
				gridOptions.editRules = {
					field: [{
						required: true
					}],
					symbol: [{
						required: true
					}]
				}
			},
			list() {
				return new Promise((resolve) => {
					resolve({
						list: this.data.rulejson
					})
				})
			},
			modal_init(){
				// let formData = JSON.parse(JSON.stringify(formjson))
				// let rule = formData.rule.rule
				// let option = formData.rule.option
				// option.el = this.$refs.logistictrace_custom_form
				// this.fApi = this.$formCreate(rule, option)
				// this.fApi.nextTick(() => {
				// 	this.regestevent(rule)
				// 	this.setFormData()		
				// })
				this.$emit('show')
			},	
			// regestevent(rule){
			// 	rule.forEach((item) => {
			// 		if (item.field) {
			// 			let on = {}
			// 			if (typeof this[item.field + 'Input'] === 'function') {
			// 				on.input = this[item.field + 'Input']
			// 			}
			// 			if (typeof this[item.field + 'Change'] === 'function') {
			// 				on.input = this[item.field + 'Change']
			// 			}
			// 			if (typeof this[item.field + 'Button'] === 'function') {
			// 				on.inputButtonclick = this[item.field + 'Button']
			// 			}				
			// 			this.fApi.updateRule(item.field, {
			// 				on: on
			// 			})
			// 		}				
			// 	})
			// },
			// setFormData(){
			// 	if(this.sourceData){
			// 		let fields = this.fApi.fields()
			// 		fields.forEach((item) => {
			// 			this.fApi.setValue(item, this.sourceData[item])
			// 		})
			// 	}
			// },
			getgrid(){
				return this.$refs.list
			},
			add(){
				let detail = this.getgrid().getTableData().visibleData
				if(detail.length){
					this.getgrid().insertAt({logic:'且'},-1)
				}else{
					this.getgrid().insertAt({},-1)
				}
				
			},
			delete(row){
				this.getgrid().remove(row)
			},
			submit() {
					this.getgrid().validate(true, (res) => {
						if (!res) {
							let detail = this.getgrid().getTableData().visibleData
							detail = JSON.parse(JSON.stringify(detail))
							detail.forEach((item,index)=>{
								if(index == 0){
									item.logic = ''
								}
								delete(item._X_ROW_CHILD)
								delete(item._X_ROW_KEY)
							})
							this.$emit('submit', {
								data: detail
							})
							this.modal_cancel()
						} else {
							for (let i in res) {
								console.log(res[i][0].rule)
								let content = res[i][0].rule.$options.content
								let message = res[i][0].rule.$options.message
								if(content){
									this.$message.error(content)
								}else if(message){
									this.$message.error(message)
								}else{
									this.$message.error('缺少必填项：' + res[i][0].column.title)
								}
								
							}
						}
					})
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k]/1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i]/1000
					}
				}
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>